<template>
	<div v-if="showTopbar" class="topbar">
		<div class="topbar-left">
			<div class="info">
	      		<span class="material-icons md-15 md-light">call</span>
	      		<p>07.76.37.47.88</p>
	    	</div>
		    <div class="info hidden-resp">
				<span class="material-icons md-15 md-light">email</span>
		      	<p>contact@lesrelaiscartegrise.fr</p>
		    </div>
		    <div class="info hidden-resp">
				<span class="material-icons md-15 md-light">location_on</span>
		      	<p>9 Allée Marie Curie - 34770 Gigean / 1 Quai Vauban - 34200 Sète</p>
		    </div>
		    <router-link to="/go/immatriculation">
		    <div v-if="completed()" class="info">
				<span class="material-icons md-15 md-light">directions_car</span>
		      	<p class="vehicule">{{this.$store.state.vehicule.Marque}} {{this.$store.state.vehicule.Modele}} {{this.$store.state.vehicule.Version}}</p>
		      	<!-- <span @click="cleanVehicule" class="material-icons md-15 md-light close">highlight_off</span> -->
		    </div>
		    </router-link>
		    
		</div>
		<div class="topbar-right">
			<!-- <p>Se connecter</p> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'Topbar',
	data () {
		return {}
	},
	computed: {
	    showTopbar () {
	      return !(
	        this.$route.path === '/go/immatriculation' &&
	        this.$route.query.pay === 'ppweb'
	      )
	    }
	},
	methods:{
		completed () {
			if(this.$store.state.vehicule.completed){
				return true;
			}else{
				return false;
			}
		},
		cleanVehicule() {
			this.$store.commit('cleanVehicule');
		}
	}
}
</script>

<style scoped>

.topbar{
	padding-left:10px;
/*	background: rgb(60,60,60);
background: linear-gradient(90deg, rgba(60,60,60,1) 20%, rgba(23,22,22,1) 100%);*/
	background: rgb(57,62,68);
	background: linear-gradient(90deg, rgba(57,62,68,1) 0%, rgba(58,62,66,1) 100%);
	color:#fbfbfb;
	height:30px;
	display:flex;
	align-items:center
}

.topbar p{
	font-size:0.8em;
	margin:0px 30px 0px 10px;
}

.topbar p.vehicule{
	margin:0px 10px 0px 10px;
}

.topbar-left{
	flex:3;
	display:flex;
	justify-content:flex-start;
	align-items:center;
}

.info{
	display:flex;
	align-items:center;
}

.topbar-right{
	flex:1;
	display:flex;
	justify-content:flex-end;
}

.close{
	cursor:pointer;

}


@media all and (max-width: 1200px) {
	.hidden-resp{display:none;}
	.topbar-left{flex:0,5;}
}

</style>



// WEBPACK FOOTER //
// src/components/Topbar.vue